/**
 * Single source of truth for the Positive Recruitment Organization entity.
 * Reused by the homepage, Insights articles and the build-time prerenderer so
 * every page describes the same company with the same @id.
 */
export const SITE = "https://positiverecruitment.io";
export const ORG_ID = `${SITE}/#organization`;

export const ORG_SAME_AS = [
  "https://www.linkedin.com/company/positive-recruitment/",
];

/** Full Organization node with company data and social profiles. */
export const organizationSchema = () =>
  ({
    "@type": "Organization",
    "@id": ORG_ID,
    name: "Positive Recruitment Sp. z o.o.",
    legalName: "Positive Recruitment Sp. z o.o.",
    alternateName: ["Positive Recruitment", "positiverecruitment.io"],
    url: `${SITE}/`,
    logo: {
      "@type": "ImageObject",
      "@id": `${SITE}/#logo`,
      url: `${SITE}/favicon-192.png`,
      contentUrl: `${SITE}/favicon-192.png`,
      width: 192,
      height: 192,
      caption: "Positive Recruitment",
    },
    image: `${SITE}/og-cover.png`,
    description:
      "Agencja rekrutacji IT z Krakowa. Direct search i sprinty rekrutacyjne dla Cloud, Big Data, AI/ML, IoT i liderów technicznych w Polsce i CEE.",
    slogan: "Less noise, more signal.",
    foundingDate: "2022",
    email: "office@positiverecruitment.io",
    telephone: "+48724440557",
    address: {
      "@type": "PostalAddress",
      streetAddress: "ul. Juliusza Lea 100/21",
      postalCode: "30-058",
      addressLocality: "Kraków",
      addressRegion: "Małopolskie",
      addressCountry: "PL",
    },
    geo: { "@type": "GeoCoordinates", latitude: 50.0716, longitude: 19.9156 },
    areaServed: ["PL", "CEE"],
    knowsLanguage: ["pl", "en", "zh"],
    numberOfEmployees: { "@type": "QuantitativeValue", value: 2 },
    founder: {
      "@type": "Person",
      "@id": `${SITE}/o-nas/wojciech-kluk#person`,
      name: "Wojciech Kluk",
      url: `${SITE}/o-nas/wojciech-kluk`,
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "sales",
        telephone: "+48724440557",
        email: "office@positiverecruitment.io",
        areaServed: ["PL", "CEE"],
        availableLanguage: ["Polish", "English", "Chinese"],
      },
    ],
    hasCredential: {
      "@type": "EducationalOccupationalCredential",
      credentialCategory: "licence",
      name: "KRAZ Employment Agency Licence",
      identifier: "27177",
      recognizedBy: {
        "@type": "GovernmentOrganization",
        name: "Krajowy Rejestr Agencji Zatrudnienia (KRAZ)",
        url: "https://kraz.praca.gov.pl/",
      },
    },
    sameAs: ORG_SAME_AS,
  }) as Record<string, unknown>;
